var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baidumap",attrs:{"id":"allmap"}},[_c('baidu-map',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.bmCenter,"scroll-wheel-zoom":true,"zoom":_vm.mapZoom,"z-index":"1"},on:{"ready":_vm.mapReady}},[_c('my-overlay',{ref:"overlay",attrs:{"active":_vm.active,"position":_vm.overlayDeviceInfo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }